import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexGrid',
  setup(__props) {

const GridOptions = defineAsyncComponent(() => import("@/components/theme/uikits/grid/GridOptions.vue"))
const GridColumm = defineAsyncComponent(() => import("@/components/theme/uikits/grid/GridColumm.vue"))
const GridAlignment = defineAsyncComponent(() => import("@/components/theme/uikits/grid/GridAlignment.vue"))
const GridSection = defineAsyncComponent(() => import("@/components/theme/uikits/grid/GridSection.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      mains: "Grid",
      title: "Grid"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(GridOptions)),
        _createVNode(_unref(GridColumm)),
        _createVNode(_unref(GridAlignment)),
        _createVNode(_unref(GridSection))
      ])
    ])
  ], 64))
}
}

})